import React from "react";
import {
    AccountBalanceWallet, AccountBalance as BankIcon, CreditCard, Wallet, Category,
} from "@mui/icons-material";
import { AccountType } from "../../types/accounts";

interface AccountTypeMeta {
    label: string;
    icon: React.ReactNode;
    /** MUI palette key for Chips (`default` has no `.light`/`.dark`, so
     * avatarBg/avatarFg spell out a real palette path for every type
     * instead of templating `${chipColor}.light`). */
    chipColor: "success" | "info" | "error" | "warning" | "default";
    avatarBg: string;
    avatarFg: string;
}

/** Shared between AccountList and AccountStatementDrawer so both surfaces
 * agree on how each account type looks — one place to update the palette
 * instead of two independent copies drifting apart. */
export const ACCOUNT_TYPE_META: Record<AccountType, AccountTypeMeta> = {
    CASH: {
        label: "Cash", icon: <AccountBalanceWallet fontSize="small" />,
        chipColor: "success", avatarBg: "success.light", avatarFg: "success.dark",
    },
    BANK: {
        label: "Bank", icon: <BankIcon fontSize="small" />,
        chipColor: "info", avatarBg: "info.light", avatarFg: "info.dark",
    },
    LOAN: {
        label: "Loan", icon: <CreditCard fontSize="small" />,
        chipColor: "error", avatarBg: "error.light", avatarFg: "error.dark",
    },
    MOBILE_WALLET: {
        label: "Mobile Wallet", icon: <Wallet fontSize="small" />,
        chipColor: "warning", avatarBg: "warning.light", avatarFg: "warning.dark",
    },
    OTHER: {
        label: "Other", icon: <Category fontSize="small" />,
        chipColor: "default", avatarBg: "grey.200", avatarFg: "grey.700",
    },
};
